import produce from 'immer';
import {
  GET_GLOBAL_LIBRARY_START,
  GET_GLOBAL_LIBRARY_SUCCESS,
  GET_GLOBAL_LIBRARY_FAILED,
  GET_MY_LIBRARY_START,
  GET_MY_LIBRARY_SUCCESS,
  GET_MY_LIBRARY_FAILED,
  DELETE_SINGLE_TEMPLATE_START,
  DELETE_SINGLE_TEMPLATE_SUCCESS,
  DELETE_SINGLE_TEMPLATE_FAILED,
  DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_START,
  DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_SUCCESS,
  DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_FAILED
} from '../actions/library';


const initialState = {
  globalLibraryData: [],
  myLibraryData: [],
  totalCount: 0,
  pages: 0,
  libraryLoading: false,
  templateDownloading: false,
  error: ''
};

const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case GET_GLOBAL_LIBRARY_START: {
      state.libraryLoading = true;
      break;
    }
    case GET_GLOBAL_LIBRARY_SUCCESS: {
      const { data } = action;
      state.globalLibraryData = data.templates;
      state.pages = data.pages;
      state.totalCount = data.totalCount;
      state.libraryLoading = false;
      break;
    }
    case GET_GLOBAL_LIBRARY_FAILED: {
      state.error = true;
      state.libraryLoading = false;
      break;
    }

    case GET_MY_LIBRARY_START: {
      state.libraryLoading = true;
      break;
    }
    case GET_MY_LIBRARY_SUCCESS: {
      const { data } = action;
      state.myLibraryData = data.templates;

      state.pages = data.pages;
      state.page = data.page;
      state.totalCount = data.totalCount;
      state.libraryLoading = false;
      break;
    }
    case GET_MY_LIBRARY_FAILED: {
      state.error = true;
      state.libraryLoading = false;
      break;
    }

    case DELETE_SINGLE_TEMPLATE_START: {
      state.libraryLoading = true;
      break;
    }
    case DELETE_SINGLE_TEMPLATE_SUCCESS: {
      const { id } = action;
      state.myLibraryData = state.myLibraryData.filter((t) => t._id !== id);
      state.totalCount = state.totalCount - 1;
      state.libraryLoading = false;
      break;
    }
    case DELETE_SINGLE_TEMPLATE_FAILED: {
      state.error = true;
      state.libraryLoading = false;
      break;
    }

    case DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_START: {
      state.templateDownloading = true;
      break;
    }
    case DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_SUCCESS: {
      const { templateId, data } = action;
      state.globalLibraryData = state.globalLibraryData.map((t) => t._id === templateId ? data.globalLibraryPromo : t);
      state.templateDownloading = false;
      break;
    }

    case DOWNLOAD_GLOBAL_LIBRARY_TEMPLATE_FAILED: {
      state.templateDownloading = false;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
